import {
  getPlatformListLocalUsersResponseMock,
  getPlatformListTeamsResponseMock,
} from '@cloudquery/api-platform';
import { getTeamMembershipMock } from '@cloudquery/base-users/src/mocks/data/teamMembership';
import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformListTeamsMockHandler = () => {
  return http.get('*/teams', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const membership = getTeamMembershipMock();

    const items = [
      {
        created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        display_name: membership.team.display_name,
        internal: true,
        is_trial_active: faker.datatype.boolean(),
        name: membership.team.name,
        plan: 'paid',
        plan_end_time: `${faker.date.past().toISOString().split('.')[0]}Z`,
        trial_end_time: `${faker.date.future().toISOString().split('.')[0]}Z`,
      },
      ...getPlatformListTeamsResponseMock().items,
    ];

    return HttpResponse.json(
      {
        ...getPlatformListLocalUsersResponseMock(),
        items,
        metadata: {
          ...getPlatformListLocalUsersResponseMock().metadata,
          total_count: items.length + 1,
        },
      },
      {
        status: 200,
      },
    );
  });
};
